export function Brand({ className }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className ?? ""}`}>
      <span className="inline-flex size-7 items-center justify-center rounded-lg bg-ink-900 text-sm font-bold text-white">P</span>
      <span className="text-lg font-bold tracking-tight text-ink-950">Payezy</span>
    </span>
  );
}
